import { render, staticRenderFns } from "./testing_center.vue?vue&type=template&id=0801f654&"
import script from "./testing_center.vue?vue&type=script&lang=js&"
export * from "./testing_center.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports